import { gql } from '@apollo/client';

const schema = {
  get: {
    name: 'product',
    serviceName: 'grapghql',
    query: gql`
      query product($ids: [String], $for_admin: Int) {
        product(ids: $ids, for_admin: $for_admin) {
          data {
            title
            weight
            num_in_box
            unit {
              id
              title
            }
            barcode
            introtext
            is_active
            category {
              id
            }
            brand {
              id
            }
          }
        }
      }
    `,
  },
  update: {
    name: 'updateProduct',
    serviceName: 'admin',
    query: gql`
      mutation updateProduct(
        $ids: [String]!
        $title: String
        $weight: String
        $num_in_box: String
        $unit_id: String
        $barcode: String
        $introtext: String
        $is_active: Int
        $brand_id: String
        $category_id: String
      ) {
        updateProduct(
          ids: $ids
          title: $title
          weight: $weight
          num_in_box: $num_in_box
          unit_id: $unit_id
          barcode: $barcode
          introtext: $introtext
          is_active: $is_active
          brand_id: $brand_id
          category_id: $category_id
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
